export function getRoute(route) {
    switch (route.name) {
        case "pages.announcements.show":
            return { name: 'Announcement Page', params: {
                id: route.parameters.announcement,
                notification_id: route.parameters.notification_id,
            } };
        case "pages.bookings.show":
            return { name: 'Booking Page', params: {
                id: route.parameters.booking,
                notification_id: route.parameters.notification_id,
            } };
    }
    

    return null;
}